// hotfix-clean-injected-soldout.js
// Purpose: clean wrongly-injected "Sold Out" labels and classes on available products.
// This file is the same logic as the inline hotfix but moved to a deferred asset.

(function () {
  'use strict';

  function clean() {
    // A. On available product buttons, remove wrongly injected "Sold Out" elements
    try {
      var soldOutEls = document.querySelectorAll('.product-card__add-button:not(.is-disabled) .product-prices__sold-out');
      soldOutEls.forEach(function(n){ n.remove(); });
    } catch (e) { /* fail silently */ }

    // B. On available product buttons, remove wrongly added "has-injected-price" class
    try {
      var btns = document.querySelectorAll('.product-card__add-button:not(.is-disabled).has-injected-price');
      btns.forEach(function(btn){ btn.classList.remove('has-injected-price'); });
    } catch (e) { /* fail silently */ }
  }

  // Initial execution
  clean();

  // Observe DOM changes (carousel / lazy-load / animation) to keep cleaning
  try {
    var mo = new MutationObserver(function(){ clean(); });
    mo.observe(document.body, { subtree:true, childList:true, attributes:true, attributeFilter:['class'] });
  } catch (e) { /* MutationObserver might not be available in some old browsers */ }

  // Extra fallbacks
  setTimeout(clean, 300);
  setTimeout(clean, 1200);

  // Optionally re-run after page becomes interactive if needed
  if (typeof window !== 'undefined') {
    if (document.readyState === 'complete') {
      // already loaded
      setTimeout(clean, 2000);
    } else {
      window.addEventListener('load', function() {
        setTimeout(clean, 600);
      }, { once: true });
    }
  }
})();
